
export class FileDetails {
    fileName: string;
    fileContents: string;
    fileLabel: string;
/**
 * @param {?} fileLabel
 * @param {?} fileName
 * @param {?} fileContents
 */
constructor (fileLabel: string, fileName: string,   fileContents: string) {
        this.fileLabel = fileLabel;
          this.fileName = fileName ;
          this.fileContents = fileContents;
    }
}

function FileDetails_tsickle_Closure_declarations() {
/** @type {?} */
FileDetails.prototype.fileName;
/** @type {?} */
FileDetails.prototype.fileContents;
/** @type {?} */
FileDetails.prototype.fileLabel;
}

